import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { useUIUtils } from 'hooks/useUIUtils';

const ListT = ({ match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { path } = match;
    const { t } = useTranslation("common");
    let [actualizarTabla, setActualizarTabla] = useState(false);
    const rol = getDataSession('rol');
    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: rol === 'EMPRESA' ? 'editar,activarUsuario,activarCuentaUsuario,enviarLinkActivacion' : 'editar', ...(rol === 'EMPRESA' && { activarUsuario: activarUsuario, activarCuentaUsuario: activarCuentaUsuario, enviarLinkActivacion: enviarLinkActivacion }) },
        { field: 'id', headerName: 'Id', maxWidth: 20, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'nombre', headerName: 'Nombre', minWidth: 300, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'correo', headerName: 'Correo', flex: 1 },
        { field: 'estatus', headerName: 'Activo', flex: 1 },
        { field: 'activacion_Correo', headerName: 'Activacion Correo', flex: 1 },
        { field: 'rol', headerName: 'Rol', flex: 1 },
        { field: 'fecha_Registro', headerName: 'Fecha Registro', flex: 1 }
    ];

    React.useEffect(() => {
        changeGlobalTitle('Usuarios', 'Lista des usuarios registrados para sus conexiones.')
        validarExisteSucursalPrincipal();
    }, [changeGlobalTitle]);

    function activarUsuario(usuario_id) {
        Swal.fire({
            title: '¿Desea activar el estatus del usuario seleccionado?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.activar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `usuarios/ActivarUsuario?usuario_id=${usuario_id}`,
                null,
                'POST'
            ).then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', 'Usuario Activado', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    function activarCuentaUsuario(usuario_id) {
        Swal.fire({
            title: '¿Desea activar la cuenta del usuario seleccionado?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.activar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `usuarios/ActivarUsuario?usuario_id=${usuario_id}&activarCuenta=true`,
                null,
                'POST'
            ).then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', 'Usuario Activado', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    function enviarLinkActivacion(usuario_id) {
        Swal.fire({
            title: '¿Desea enviar el correco de activacion del usuario seleccionado?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.aceptar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(`usuarios/EnviarLink?usuario_id=${usuario_id}&validarCuentaActiva=true`, null, 'POST').then(function (response) {
                if (response.hasOwnProperty('status') && response.status === 400) Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                else if (response.hasOwnProperty('codigo') && response.codigo !== 200) Swal.fire('Error', response.mensajes[0], 'error');
                else {
                    Swal.fire('Exito', 'Correo enviado', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                }
            });
        })
    }

    return (<>
        <div className='container-fluid'>
            <div className='col-md-12'>
                <div className='col-md-12'>
                    <Link to={`${path}/add`} className='btn btn-outline-primary'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-plus-square'
                            viewBox='0 0 16 16'
                        >
                            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                        </svg>
                        &nbsp; Nuevo
                    </Link>
                    &nbsp; &nbsp;
                </div>
            </div>
            <div style={{ height: 400, width: '100%' }}>
                <ListTable
                    columns={columns}
                    path={path}
                    url={`usuarios/GetList?`}
                    reload={actualizarTabla}
                />
            </div>

        </div>
    </>);
};

export { ListT };